<script>
    export let sort = '';
</script>

<div class="sort-arrows">
    <div class="arrow up" class:active="{ sort === 'DESC' }">
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 1792 1792" fill="currentColor">
            <path d="M1408 704q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z"/>
        </svg>
    </div>
    <div class="arrow down" class:active="{ sort === 'ASC' }">
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 1792 1792"
             fill="currentColor">
            <path d="M1408 1088q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z"/>
        </svg>
    </div>
</div>

<style>
    .sort-arrows {
        position: relative;
        width: 10px;
        height: 14px;
    }

    .sort-arrows .arrow {
        position: absolute;
        width: 100%;
        height: 10px;
        left: 50%;
        transform: translateX(-50%);
        color: #ccc;
    }

    .sort-arrows .arrow.up {
        top: -5px;
    }

    .sort-arrows .arrow.down {
        bottom: 8px;
    }

    .sort-arrows .arrow.active {
        color: #666;
    }
</style>